// src/serviceWorkerRegistration.js

// 检查浏览器是否支持 Service Worker
const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.\d+){0,3}\.\d+$/
    )
  );
  
  export function register(config) {
    if ('serviceWorker' in navigator) {
      const publicUrl = new URL(
        process.env.PUBLIC_URL,
        window.location.href
      );
      if (publicUrl.origin !== window.location.origin) {
        return;
      }
  
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  
        if (isLocalhost) {
          // 在 localhost 上，检查 Service Worker 更新
          checkValidServiceWorker(swUrl, config);
        } else {
          // 在生产环境中，直接注册 Service Worker
          registerValidSW(swUrl, config);
        }
      });
    }
  }
  
  function registerValidSW(swUrl, config) {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // 新的内容可用
                console.log(
                  '新内容可用; 请刷新页面。'
                );
                if (config && config.onUpdate) {
                  config.onUpdate(registration);
                }
              } else {
                // 内容已缓存
                console.log('内容已缓存。');
                if (config && config.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error('注册 Service Worker 失败:', error);
      });
  }
  
  function checkValidServiceWorker(swUrl, config) {
    fetch(swUrl, {
      headers: { 'Service-Worker': 'script' },
    })
      .then((response) => {
        // 确保我们得到了有效的响应
        const contentType = response.headers.get('content-type');
        if (
          response.status === 404 ||
          (contentType != null && contentType.indexOf('javascript') === -1)
        ) {
          // 没有找到 Service Worker，可能是因为它没有被注册
          navigator.serviceWorker.ready.then((registration) => {
            registration.unregister().then(() => {
              window.location.reload();
            });
          });
        } else {
          // 有效的 Service Worker
          registerValidSW(swUrl, config);
        }
      })
      .catch(() => {
        console.log(
          '没有网络连接。无法注册 Service Worker。'
        );
      });
  }
  